module.exports = __webpack_public_path__ + "static/media/Dividend.c7e0191a.png";